import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { VeriffMetadataType } from 'data/App/types'
import { call, put, select, take } from 'redux-saga/effects'
import { syncVeriff as sycnVeriffApi } from 'services/api/kyc'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* veriffStep() {}

export function* syncVeriff() {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', true))

  const veriffMetadata: VeriffMetadataType = yield select(selectors.app.getVeriffMetadata)

  const data: Response<void> = yield call(sycnVeriffApi, veriffMetadata)

  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_TIER_TWO')
    return
  }
  yield put(actions.auth.getUser())
  yield take(actionTypes.auth.SET_USER)
  const isHighRisk: boolean = yield select(selectors.auth.isHighRisk)

  yield put(actions.auth.pollUser())

  if (isHighRisk) {
    yield call(goToStep, 'edd')
  } else {
    yield call(goToStep, 'final')
  }
}
